import React, { useEffect, useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import "./Campanhas.css";
import useAuth from "../../../components/hooks/useAuth";
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";

const HEADER_HEIGHT = 56;

// Troque para um state para permitir adicionar campanhas dinamicamente
const Campanha = () => {
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [novaCampanha, setNovaCampanha] = useState({ nome: "", tipo: "" });
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);

  const { sidebarOpen, getApi, postApi } = useAuth();
  const navigate = useNavigate(); // NOVO: hook para navegação

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    setLoading(true);
    let response = await getApi("/api/v1/campaign/list", []);

    setCampaigns(response.lista);
    setLoading(false);
  };

  // Detecta se está em mobile
  const isMobile = window.innerWidth <= 768;

  // Selecionar/desselecionar todas
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCampaigns(campaigns.map((c) => c.id));
    } else {
      setSelectedCampaigns([]);
    }
  };

  // Selecionar/desselecionar individual
  const handleSelectCampaign = (id) => {
    setSelectedCampaigns((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  // Enviar selecionadas (exemplo)
  const handleDispararSelecionadas = () => {
    alert(`Enviar campanhas: ${selectedCampaigns.join(", ")}`);
  };

  // Modal handlers
  const handleOpenModal = () => {
    setNovaCampanha({ nome: "", tipo: "" });
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const handleChangeNovaCampanha = (e) => {
    setNovaCampanha({ ...novaCampanha, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <PrivateMenuLeft />
      <PrivateMenuUp />

      <Helmet>
        <title>{`Minhas Campanhas'}`}</title>
      </Helmet>

      {/* Conteúdo da página de campanha */}
      <div
        style={{
          marginLeft: isMobile ? 56 : sidebarOpen ? 220 : 70,
          paddingTop: HEADER_HEIGHT,
          width: isMobile
            ? "calc(100vw - 56px)"
            : sidebarOpen
              ? "calc(100% - 220px)"
              : "calc(100% - 70px)",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        }}
      >
        <div style={{ padding: 32 }}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 style={{ fontWeight: "bold" }}>Minhas Campanhas</h2>
            <button
              type="button"
              className="btn btn-link"
              style={{
                color: "#51a197",
                fontSize: 22,
                fontWeight: 600,
                textDecoration: "none",
              }}
              onClick={handleOpenModal}
              title="Adicionar campanha"
            >
              <i className="bi bi-plus-circle"></i>{" "}
              <span className="d-none d-md-inline">Adicionar</span>
            </button>
          </div>

          {loading && <Loader />}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 24,
              marginTop: 24,
            }}
          >

            {campaigns.map((camp) => (
              <div
                key={camp.id}
                className="card"
                style={{
                  width: 320,
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  background: "#fff",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 24,
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "3px solid #51a197",
                      background: "#eee",
                      position: "relative",
                    }}
                    onClick={() => navigate(`/campanha/${camp.id}`)}
                  >
                    <img
                      src={camp.picture_url ? camp.picture_url : "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=100&q=80"}
                      alt="Capa"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    {/* Ícone pulsando */}
                    <span
                      style={{
                        position: "absolute",
                        bottom: 6,
                        right: 6,
                        width: 32,
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          background:
                            camp.membros > 0
                              ? "rgba(40, 199, 111, 0.3)"
                              : "rgba(255, 167, 38, 0.3)",
                          animation: "pulse 1.2s infinite",
                        }}
                      ></span>
                      <span
                        style={{
                          position: "relative",
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          background: camp.alive ? "#28c76f" : "#ffa726",
                          border: "3px solid #fff",
                          zIndex: 1,
                        }}
                      ></span>
                    </span>
                  </span>
                </div>
                <div style={{ padding: 20, textAlign: "center" }}>
                  <h5 style={{ margin: 0, fontWeight: "bold" }}>{camp.nane}</h5>
                  {/* Removido o tipo, agora mostra o nome do grupo */}
                  <span style={{ color: "#005c53", fontWeight: 600 }}>
                    {camp.name || "Nome do grupo"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Modal de adicionar campanha */}
      </div>
      <style>
        {`
      @keyframes pulse {
        0% {
          transform: scale(0.8);
          opacity: 0.7;
        }
        70% {
          transform: scale(1.4);
          opacity: 0;
        }
        100% {
          transform: scale(0.8);
          opacity: 0;
        }
      }
      `}
      </style>
    </div>
  );
};

export default Campanha;
